export default class Position {
    constructor(public lat: number, public lng: number) {
        this.lat = lat;
        this.lng = lng;
    }
}



// WEBPACK FOOTER //
// ./scripts/views/components/ui-maps/position.ts